module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: ({
      'text-align': 'center',
      'max-width': '1440px',
      'margin': '0 auto'
    }),
    attrs: {
      "id": "videovuer"
    }
  }, [_c('ScaleOut', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading-icon"
  }), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getDataOk),
      expression: "getDataOk"
    }],
    staticClass: "fullscreen-btn",
    attrs: {
      "title": _vm.fullscreentitle
    },
    on: {
      "click": _vm.toggle
    }
  }, [_c('img', {
    staticClass: "fullscreen-icon",
    attrs: {
      "src": require("../../assets/icon/ic_fullscreen.png"),
      "alt": "F"
    }
  })]), _vm._v(" "), (_vm.getDataOk) ? _c('video-player', {
    ref: "videoPlayer",
    staticClass: "vvjs-custom-skin",
    attrs: {
      "options": _vm.playerOptions,
      "playsinline": true,
      "customEventName": "customstatechangedeventname"
    },
    on: {
      "play": function($event) {
        return _vm.onPlayerPlay($event)
      },
      "pause": function($event) {
        return _vm.onPlayerPause($event)
      },
      "ended": function($event) {
        return _vm.onPlayerEnded($event)
      },
      "waiting": function($event) {
        return _vm.onPlayerWaiting($event)
      },
      "playing": function($event) {
        return _vm.onPlayerPlaying($event)
      },
      "loadeddata": function($event) {
        return _vm.onPlayerLoadeddata($event)
      },
      "timeupdate": function($event) {
        return _vm.onPlayerTimeupdate($event)
      },
      "canplay": function($event) {
        return _vm.onPlayerCanplay($event)
      },
      "canplaythrough": function($event) {
        return _vm.onPlayerCanplaythrough($event)
      },
      "statechanged": function($event) {
        return _vm.playerStateChanged($event)
      },
      "ready": _vm.playerReadied
    }
  }) : _vm._e(), _vm._v(" "), (_vm.systemAdminMode === false) ? _c('WaterMark', {
    attrs: {
      "inputText": _vm.inputText
    }
  }) : _vm._e(), _vm._v(" "), _c('hint', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hint.display && this.$store.state.hintStatus.videoView),
      expression: "hint.display && this.$store.state.hintStatus.videoView"
    }],
    attrs: {
      "message": _vm.hint.message
    },
    on: {
      "close": _vm.closeHint
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d7d4662c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/nav1/Video.vue
// module id = 962
// module chunks = 170